<!--<button (click)="init()">Init</button>-->
<div [chart]="chart"></div>